import { createReducer } from 'modules/redux-utils'
import actionTypes from './actionTypes'
import { RatingAreaRecalculationResult } from './types'

interface RatingAreaRecalculationState {
  isRecalculating: boolean
  lastResult: RatingAreaRecalculationResult | null
  error: string | null
}

const initialState: RatingAreaRecalculationState = {
  isRecalculating: false,
  lastResult: null,
  error: null,
}

export default createReducer(initialState, {
  [actionTypes.RECALCULATE_RATING_AREAS]: (state: RatingAreaRecalculationState) => ({
    ...state,
    isRecalculating: true,
    error: null,
  }),
  [actionTypes.RECALCULATE_RATING_AREAS_SUCCESS]: (state: RatingAreaRecalculationState, payload: RatingAreaRecalculationResult) => ({
    ...state,
    isRecalculating: false,
    lastResult: payload,
    error: null,
  }),
  [actionTypes.RECALCULATE_RATING_AREAS_ERROR]: (state: RatingAreaRecalculationState, payload: string) => ({
    ...state,
    isRecalculating: false,
    error: payload,
  }),
})
